<template>
  <div class="app-container">
    <navigation title="今日数据"></navigation>
    <div class="main">
      <div class="to-venues">
        <div class="data-num">
          <p class="num">{{ dataList.visitorsTimes }}</p>
          <p>人次</p>
        </div>
        <div class="data-title">
          <p>到馆量</p>
          <p>（到馆人次）</p>
        </div>
      </div>
      <div class="web-site">

      </div>
      <div class="borrowed">

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup, Tab, Tabs, Picker } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Tab).use(Tabs).use(Picker)

export default {
  name: 'statistical',
  components: {navigation},
  data () {
    return {
      dataList: ''
    }
  },
  created () {
    // 获取动态数据
    this.getData()
    // 是否显示动态数据
    this.getIsData()
  },
  methods: {
    // 返回上一页
    onClickLeft () {
      this.$router.go(-1)
    },
    // 获取动态数据
    getData () {
      request('get', '/nlc-web/api/dynamicData').then(res => {
        console.log('动态数据', res)
        this.dataList = res.data
      })
    },
    // 是否显示动态数据
    getIsData  () {
      request('get', '/nlc-web/api/control/realtimeData').then(res => {
        console.log('是否显示动态数据', res)
        // this.idData
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: calc(100% - 46px);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.main{
  margin-top:.92rem;
  padding:.3rem .28rem;
}
.to-venues{
  width:6.94rem;
  height:4.08rem;
  background: url(../../assets/img/data-bg.png) no-repeat;
  background-size:100%;
  position:relative;
}
.data-num{
  position:absolute;
  right:.88rem;
  top:.75rem;
  width:2.57rem;
  height:2.58rem;
  background: url(../../assets/img/data-num.png) no-repeat;
  background-size:100%;
  font-size:.20rem;
  color:#008598;
  text-align:center;
  padding-top:.97rem;
}
.num{
  font-size:.36rem;
}
.data-num p{
  margin:0;
}
.data-title{
  width: 2.16rem;
  height: 1.02rem;
  font-size: .36rem;
  font-family: SourceHanSerifCN-Bold;
  font-weight: bold;
  color: #008598;
  text-align: center;
  padding:1.53rem 0 0 .89rem;
}
.data-title p{
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/view/statistical/index.vue